import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Switch, Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { BindingGroupModel } from '../../models';
import { hasPermission, hasObjectPermission } from '../../../authorization/components/HasPermission';
import { AppPermissions } from '../../../authorization/Permissions';
import AuthContext from '../../../authorization/AuthContext';
import './BindingGroupExtraRenderer.less';

interface Props {
    bindingGroup: BindingGroupModel;
    projectId?: string;
}

const BindingGroupExtraRenderer: React.FC<Props> = ({ bindingGroup, projectId }) => {
    const authContext = React.useContext(AuthContext);
    const canEdit =
        hasPermission(authContext.permissions, AppPermissions.CanEditIotaApplications) ||
        hasObjectPermission(authContext.objectPermissions, projectId, AppPermissions.CanEditIotaApplications);

    return (
        <div className="binding-group-extra-renderer">
            <Button
                type="link"
                size="small"
                disabled={!canEdit}
                onClick={e => {
                    e.stopPropagation();
                    bindingGroup.setEditable(!bindingGroup.editable);
                }}
            >
                <EditOutlined />
            </Button>

            <div onClick={e => e.stopPropagation()}>
                <Switch
                    size="small"
                    checked={bindingGroup.enabled}
                    onChange={bindingGroup.setEnabled}
                    disabled={!canEdit}
                />
            </div>
        </div>
    );
};

export default observer(BindingGroupExtraRenderer);
